export function validateInteger(data: string): string {
  if (data.toString() !== data.toString().replace(/\D/, "")) {
    return "Only enter Integers for this field!";
  }
  return "";
}
